import academy from "./academy.png";
import freeLesson from "./freeLesson.png";
import trial from "./trial.png";

export { academy, freeLesson, trial };
